





















import { Component, Prop, Vue } from "vue-property-decorator";
import "@/styles/main.scss";

@Component
export default class HeroComponent extends Vue {}
